import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import { PrimaryColor } from "assets/theme/base/themeColors";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function StoresOrdersTableData(users, handleEditClick, fetchUsers) {
  const [isActive, setIsActive] = useState(true);
  console.log(users);
  const navigate = useNavigate();

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    // التحقق من الصلاحيات أولًا
    if (user.type === "administrator" || user.type === "admin") {
      Swal.fire({
        icon: "error",
        title: "غير مسموح!",
        text: "صلاحيات الحذف مقصورة على المشرفين",
        confirmButtonText: "حسنًا",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      return;
    }

    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف الطلب "${user.name || "غير محدد"}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: false,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/administrator/orders/delete/${user.id || 0}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف الطلب بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    if (user.type === "administrator" || user.type === "admin") {
      Swal.fire({
        icon: "error",
        title: "فشل تحديث حالة الطلب",
        text: "ليس لديك صلاحية تعديل حالة المسؤول",
      });
      return;
    }
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/administrator/orders/active/${user.id || 0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة الطلب بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name, email, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar
        src={image}
        name={name}
        size="sm"
        sx={{
          // 1. الخلفية الرمادية عند عدم وجود صورة
          backgroundColor: !image ? "grey.300" : "rgba(0, 0, 0, 0)",
          // 2. تحديد الحجم الجديد
          width: 40,
          height: 40,
          // 3. التأكد من الشكل الدائري
          borderRadius: "50%",
          // 4. تنسيق محتوى الأيقونة
          "& .MuiSvgIcon-root": {
            fontSize: "1rem", // تكبير حجم الأيقونة
          },
        }}
      >
        {!image && <PersonIcon fontSize="small" />}
      </MDAvatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "success" : "dark"}
        variant="gradient"
        sx="larg"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "رقم الطلب", accessor: "order_number", width: "30%", align: "left" },
      { Header: "العميل", accessor: "customer", align: "center" },
      { Header: "طريقة الدفع", accessor: "payment_method", align: "center" },
      { Header: "طريقة الشحن", accessor: "shipping_method", align: "center" },
      { Header: "تكلفة الشحن", accessor: "shipping_cost", align: "center" },
      { Header: "حالة الدفع", accessor: "payment_status", align: "center" },
      { Header: "حالة الطلب", accessor: "status", align: "center" },
      { Header: "اجمالي السعر", accessor: "total_price", align: "center" },
      { Header: "اجمالي الضريبة", accessor: "total_tax", align: "center" },
      { Header: "اجمالي الخصم", accessor: "total_discount", align: "center" },
      { Header: "العملة", accessor: "currency", align: "center" },
      { Header: "اجمالي المبلغ", accessor: "total_amount", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: users.map((user) => ({
      id: user.id || 0, // إضافة حقل id للوصول إليه في التوسيع
      order_number: user.id || 0,
      customer: (
        <MDTypography
          variant="caption"
          sx={{ color: "primary.light !important", fontSize: "17px" }}
          fontWeight="medium"
        >
          {user.name || "--"}
        </MDTypography>
      ),
      payment_method: (
        <MDTypography
          variant="caption"
          sx={{ color: " #ca9937 !important", fontSize: "20px !important" }}
          fontWeight="medium"
        >
          {user.payment_method?.name || "--"}
        </MDTypography>
      ),
      shipping_method: (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          sx={{ color: " #ca9937 !important", fontSize: "20px !important" }}
        >
          {user.shipping_method?.name || "--"}
        </MDTypography>
      ),
      shipping_cost: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.shipping_cost || "--"}
        </MDTypography>
      ),
      payment_status: (
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="medium"
          sx={{
            backgroundColor: user.is_paid ? "primary.light" : "dark.main",
            padding: "5px 10px",
            borderRadius: "5px",
            color: "white !important",
          }}
        >
          {user.is_paid ? "مدفوع" : "غير مدفوع"}
        </MDTypography>
      ),
      status: user.status || "--",
      total_price: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.total_price || "--"}
        </MDTypography>
      ),
      total_tax: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.tax_total || "--"}
        </MDTypography>
      ),
      total_discount: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.total_discount || "--"}
        </MDTypography>
      ),
      currency: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.currency?.name || "--"}
        </MDTypography>
      ),
      total_amount: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.total || "--"}
        </MDTypography>
      ),
      customer_addresse: user.customer_addresse || null,
      order_store: user.order_store || [],
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          {/* زر المعاينة */}
          <Tooltip title="معاينة التفاصيل" arrow>
            <Button
              variant="contained"
              color="error"
              startIcon={<VisibilityIcon />}
              sx={{
                fontWeight: "bold",
                px: 2,
                borderRadius: 2,
                boxShadow: 2,
                textTransform: "none",
                fontSize: 16,
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                  color: "#fff",
                  boxShadow: 4,
                  transform: "scale(1.04)",
                },
              }}
              onClick={() => navigate(`/stores_orders/details/${user.id || 0}`)}
            >
              معاينة التفاصيل
            </Button>
          </Tooltip>
          {/* باقي الإجراءات (تفعيل/تعديل/حذف) */}
          {/* ... existing action buttons ... */}
        </MDBox>
      ),
    })),
  };
}
